<template>
  <div class="auth-content">
    <div class="auth-title"><strong>LEVEL 0</strong> {{ $t("mypage.verify.emailVerification") }}{{$t("Verification.common.required")}}</div>
    <div class="sub-title">-{{$t("Verification.common.email.description")}}</div>
    <div class="auth-line auth" flex fic fjb>
      <div class="data" flex>
        <div class="icon-email"></div>
        <div class="ml29">
          {{ $t("mypage.modify.이메일") }}
          <br>
          <span v-if="Server.version < 10">{{ emailMasking(email) }}</span>
          <span v-else>{{ email }}</span>
        </div>
      </div>
      <div class="status en-small">
        {{ $t("mypage.verify.verificationComplete") }}
        <img src="../../../../../src/assets/img/mypage/check_ic.svg" class="ml4" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import Masking from "@/common/masking.js";
import { mapState } from "vuex";

export default {
  props: ["step", "email"],
  computed: {
    ...mapState(["Server"])
  },
  methods: {
    // 이메일 마스킹 : @앞 세 자리
    emailMasking(_value) {
      return Masking.emailMasking(_value);
    }
  }
};
</script>
